var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-30"
  }, [_c('h2', {
    staticClass: "main-tit visual__tit"
  }, [_vm._v(" 글로벌 생산성 및 친환경 ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" 메이텍스타일(Meitextile)은 매년 R&D의 장점을 활용하여 ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" 글로벌 생산성과 빠른 대응으로 시장 트렌드에 발맞추며, ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" 지속 가능한 친환경 아이템 개발에 힘쓰고 있습니다. ")])])])]), _c('div', {
    staticClass: "video-bg"
  }, [_c('video', {
    staticClass: "video-bg__video",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": "",
      "autoplay": "",
      "poster": "/images/main/visual-poster.jpg"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/images/main/visual.mp4",
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])]), _c('div', {
    staticClass: "main-contents"
  }, [_c('section', {
    staticClass: "main-section main-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "prd-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "control-top"
  }, [_c('h2', {
    staticClass: "main-tit mb-lg-46 mb-xl-92",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Product")]), _c('div', {
    staticClass: "pagination"
  })]), _c('div', {
    staticClass: "control-bottom"
  }, [_c('v-btn', {
    staticClass: "prev-btn",
    attrs: {
      "icon": "",
      "tile": "",
      "large": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "next-btn",
    attrs: {
      "icon": "",
      "tile": "",
      "large": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1)]), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/organic",
      "mainImage": "/images/main/prd-1.jpg",
      "slideImage1": "/images/main/prd-1-1.jpg",
      "slideImage2": "/images/main/prd-1-2.jpg",
      "slideImage3": "/images/main/prd-1-3.jpg",
      "slideImage4": "/images/main/prd-1-4.jpg",
      "slideImage5": "/images/main/prd-1-5.jpg",
      "tit": "Organic Line"
    }
  }, [_vm._v(" 유기농 코튼, BCI코튼, 리싸이클 폴리에스터, 대나무 섬유, 옥수수 섬유(소로나), 에코베로 등. 환경 문제가 대두됨에 따라 원단 시장 또한 변화하고 있습니다. 메이텍스는 환경 인증된 공장들과 협력하며 다양한 친환경 소재를 다루고 있습니다. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/sports",
      "mainImage": "/images/main/prd-2.jpg",
      "slideImage1": "/images/main/prd-2-1.jpg",
      "slideImage2": "/images/main/prd-2-2.jpg",
      "slideImage3": "/images/main/prd-2-3.jpg",
      "tit": "High Function Sports Line"
    }
  }, [_vm._v(" 방습성/발수성, 쿨링/히팅 기능으로 소비자의 건강한 삶을 도와줍니다. 기능성 실과 니팅 구조로 다양한 기능성을 구체화 시킵니다. 소비자의 삶을 풍요롭게 하는 다양한 아이템을 만나보세요. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/active",
      "mainImage": "/images/main/prd-3.jpg",
      "slideImage1": "/images/main/prd-3-1.jpg",
      "slideImage2": "/images/main/prd-3-2.jpg",
      "slideImage3": "/images/main/prd-3-3.jpg",
      "slideImage4": "/images/main/prd-3-4.jpg",
      "slideImage5": "/images/main/prd-3-5.jpg",
      "tit": "Active & Legging line"
    }
  }, [_vm._v(" 프린팅과 포일 디자인을 더한 싱글/더블 니트, 다양한 패턴의 엠보싱, 고신축성과 리커버리를 가진 아이템. 스포츠 및 레깅스 아이템에 대해 경험이 풍부하며 합리적인 가격으로 많은 브랜드와 협력하고 있습니다. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/cotton",
      "mainImage": "/images/main/prd-4.jpg",
      "slideImage1": "/images/main/prd-4-1.jpg",
      "slideImage2": "/images/main/prd-4-2.jpg",
      "slideImage3": "/images/main/prd-4-3.jpg",
      "slideImage4": "/images/main/prd-4-4.jpg",
      "slideImage5": "/images/main/prd-4-5.jpg",
      "tit": "Cotton & Basic Line"
    }
  }, [_vm._v(" 싱글/더블 니트와 립, 테리, 트리코트, BCI 코튼 US 코튼, 유기농 코튼, 실켓 코튼과 더불어 다양한 혼방 섬유를 다룹니다. 고급스러운 코튼 원단부터 합리적인 가격의 옵션까지 커버하는 베이직 니트 아이템을 생산합니다. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/fleece",
      "mainImage": "/images/main/prd-5.jpg",
      "slideImage1": "/images/main/prd-5-1.jpg",
      "slideImage2": "/images/main/prd-5-2.jpg",
      "slideImage3": "/images/main/prd-5-3.jpg",
      "slideImage4": "/images/main/prd-5-4.jpg",
      "slideImage5": "/images/main/prd-5-5.jpg",
      "tit": "Fleece & Sherpa Line"
    }
  }, [_vm._v(" 단/장 섬유의 셰르파와 폴라 플리스, 밍크 플리스, 테리 플리스, 벨루어, 브러쉬드 니트 등. 합성, 혼방 섬유 셰르파와 플리스 원단에 풍부한 경험을 가지며, 특히 뛰어난 품질과 가격을 만나보실 수 있습니다. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/novelty",
      "mainImage": "/images/main/prd-6.jpg",
      "slideImage1": "/images/main/prd-6-1.jpg",
      "slideImage2": "/images/main/prd-6-2.jpg",
      "slideImage3": "/images/main/prd-6-3.jpg",
      "slideImage4": "/images/main/prd-6-4.jpg",
      "slideImage5": "/images/main/prd-6-5.jpg",
      "tit": "Novelty Line"
    }
  }, [_vm._v(" 번아웃과 고급스러운 나염, 특별한 후가공, 다양한 패턴의 자카드와 엠보싱 등. 한국의 숙련된 기술로 가공한 특별한 품목들을 만나실 수 있습니다. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/ko/product/Comfortable",
      "mainImage": "/images/main/prd-7.jpg",
      "slideImage1": "/images/main/prd-7-1.jpg",
      "slideImage2": "/images/main/prd-7-2.jpg",
      "slideImage3": "/images/main/prd-7-3.jpg",
      "slideImage4": "/images/main/prd-7-4.jpg",
      "slideImage5": "/images/main/prd-7-5.jpg",
      "tit": "Comfortable & Cozy Line"
    }
  }, [_vm._v(" 싱글니트와 타월 테리, 플리스, 텍스쳐 니트 등. 브러쉬 효과와 더불어 다양한 조직을 구현합니다. 홈웨어와 더불어 다양한 룩을 연출하는 소프트 니트 라인은 소비자에게 편안함과 쾌적함을 선사합니다. ")])], 1)])])])])], 1), _c('section', {
    staticClass: "main-section main-section--last"
  }, [_c('v-container', [_c('h2', {
    staticClass: "main-tit text-center",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Partner Brand")]), _c('v-row', _vm._l(_vm.banners, function (banner, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "partner-thum-wrap"
    }, [_c('v-img', {
      staticClass: "partner-thum",
      attrs: {
        "src": banner.slides[0].image
      }
    })], 1)]);
  }), 1), _c('div', {
    staticClass: "mt-10 mt-lg-24",
    attrs: {
      "id": "moreView"
    }
  }, [_c('v-row', _vm._l(_vm.banners2, function (banner, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "partner-thum-wrap"
    }, [_c('v-img', {
      staticClass: "partner-thum",
      attrs: {
        "src": banner.slides[0].image
      }
    })], 1)]);
  }), 1)], 1), _c('div', {
    staticClass: "d-flex justify-center mt-40 mt-lg-80"
  }, [_c('div', {
    attrs: {
      "id": "moreBtn"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-160px min-w-lg-200px",
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("View All "), _c('span', {
    staticClass: "ml-6 ml-lg-10 plus more-view-btn"
  })])], 1)])], 1)], 1)]), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }